var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2443 5.74279H7.26181V0.758743C7.26181 0.339438 6.92238 0 6.50307 0C6.08377 0 5.74433 0.339438 5.74433 0.758743V5.74126H0.758743C0.339438 5.74126 0 6.08069 0 6.5C0 6.9193 0.339438 7.25874 0.758743 7.25874H5.74126V12.2413C5.74126 12.6606 6.08069 13 6.5 13C6.9193 13 7.25874 12.6606 7.25874 12.2413V7.25874H12.2413C12.6606 7.25874 13 6.9193 13 6.5C13 6.08069 12.6606 5.74126 12.2413 5.74126L12.2443 5.74279Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconDark);
export default __webpack_public_path__ + "static/media/plus-icon-dark.da4db3378d9944b8009fdb66468f8427.svg";
export { ForwardRef as ReactComponent };